import { AutoAwesome, IntegrationInstructions, RocketLaunch, Security } from '@mui/icons-material';
import { Box, Card, CardContent, Container, Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useThemeStore } from '@/stores/use-theme-store';

const features = [
    { icon: <AutoAwesome sx={{ fontSize: 40 }} />, titleKey: 'landing.features.ai.title', descKey: 'landing.features.ai.description' },
    { icon: <IntegrationInstructions sx={{ fontSize: 40 }} />, titleKey: 'landing.features.integration.title', descKey: 'landing.features.integration.description' },
    { icon: <RocketLaunch sx={{ fontSize: 40 }} />, titleKey: 'landing.features.productivity.title', descKey: 'landing.features.productivity.description' },
    { icon: <Security sx={{ fontSize: 40 }} />, titleKey: 'landing.features.security.title', descKey: 'landing.features.security.description' },
];

export function FeaturesSection() {
    const { t } = useTranslation();
    const { mode } = useThemeStore();

    return (
        <Box
            sx={{
                py: { xs: 8, md: 12 },
                bgcolor: mode === 'dark' ? '#11132B' : '#FAFBFC',
            }}
        >
            <Container maxWidth="lg">
                <Box sx={{ textAlign: 'center', mb: 8 }}>
                    <Typography
                        variant="h3"
                        sx={{
                            fontWeight: 700,
                            mb: 2,
                            fontSize: { xs: '1.8rem', md: '2.5rem' },
                        }}
                    >
                        {t('landing.features.title')}
                    </Typography>
                    <Typography variant="h6" color="text.secondary" sx={{ fontWeight: 400 }}>
                        {t('landing.features.subtitle')}
                    </Typography>
                </Box>

                <Grid container spacing={4}>
                    {features.map((feature) => (
                        <Grid size={{ xs: 12, sm: 6, md: 3 }} key={feature.titleKey}>
                            <Card
                                sx={{
                                    height: '100%',
                                    textAlign: 'center',
                                    transition: 'all 0.3s ease',
                                    border: '1px solid',
                                    borderColor: mode === 'dark' ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.06)',
                                    bgcolor: mode === 'dark' ? '#1A1C3E' : '#FFFFFF',
                                    '&:hover': {
                                        transform: 'translateY(-4px)',
                                        boxShadow: mode === 'dark'
                                            ? '0 12px 40px rgba(243,147,35,0.15)'
                                            : '0 12px 40px rgba(0,0,0,0.1)',
                                    },
                                }}
                            >
                                <CardContent sx={{ p: 4 }}>
                                    <Box
                                        sx={{
                                            mb: 2,
                                            color: 'primary.main',
                                            display: 'flex',
                                            justifyContent: 'center',
                                        }}
                                    >
                                        {feature.icon}
                                    </Box>
                                    <Typography variant="h6" sx={{ fontWeight: 600, mb: 1.5 }}>
                                        {t(feature.titleKey)}
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.7 }}>
                                        {t(feature.descKey)}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </Box>
    );
}

export default FeaturesSection;
